import { jsx as n } from "react/jsx-runtime";
import { cn as r } from "./designsystem-ui-react47.js";
function w({ align: t = "left", className: e, children: s }) {
  return /* @__PURE__ */ n("div", { className: r("tw-flex tw-items-center tw-gap-3 tw-mt-auto", {
    left: "tw-justify-start",
    center: "tw-justify-center",
    right: "tw-justify-end",
    between: "tw-justify-between"
  }[t], e), children: s });
}
export {
  w as CardActions
};
